module.exports = __webpack_public_path__ + "static/media/logo-wht.verde.e99ece9c.png";